import React from 'react';
import { useSelector } from 'react-redux';
import { SMS_IDENTITY_PROVIDER } from '@src/constants';
import { StyledBuyPackage } from './index.style';
import SMSPackages from '../PackagesNew/PackageSMS';
import NewPricingModelV3 from '../NewPricingModelV3';

const BuyPackage = () => {
  const { identityProvider } = useSelector((state) => state.auth.user);
  const isSMSUser = Object.values(SMS_IDENTITY_PROVIDER).includes(
    identityProvider,
  );

  const renderScreenPackage = () => {
    if (!isSMSUser) return <NewPricingModelV3 />;
    return <SMSPackages />;
  };

  return <StyledBuyPackage>{renderScreenPackage()}</StyledBuyPackage>;
};

export default BuyPackage;
